import { Vector } from 'p5'
import { Point } from '../../types'
import { BezierLineMarkerRenderer } from '../bezier/bezierLineMarkerRenderer'

class MeasurementMarkerRenderer extends BezierLineMarkerRenderer {
  constructor(marker) {
    super(marker)
  }

  /**
   * Draw perpendicular cap lines at both ends of the main line.
   * @param p1 {Point} - Start point of the main line
   * @param p2 {Point} - End point of the main line
   * @param length {number} - Length of each cap line
   */
  drawCapLines(p1: Point, p2: Point, length: number) {
    const p = this.marker.p
    const p1Vect = p.createVector(p1.x, p1.y)
    const p2Vect = p.createVector(p2.x, p2.y)
    const direction = Vector.sub(p2Vect, p1Vect)
    direction.normalize()

    // Compute a perpendicular direction vector
    const perpendicular = p.createVector(-direction.y, direction.x)

    const p1VectMult = p.createVector()
    const p2VectMult = p.createVector()

    Vector.mult(perpendicular, length / 2, p1VectMult)
    Vector.mult(perpendicular, length / 2, p2VectMult)

    // Calculate start and end points of the cap line at p1
    const capStart1 = Vector.add(p1Vect, p1VectMult)
    const capEnd1 = Vector.sub(p1Vect, p1VectMult)

    // Calculate start and end points of the cap line at p2
    const capStart2 = Vector.add(p2Vect, p2VectMult)
    const capEnd2 = Vector.sub(p2Vect, p2VectMult)

    // Draw cap line at p1
    p.line(capStart1.x, capStart1.y, capEnd1.x, capEnd1.y)
    // Draw cap line at p2
    p.line(capStart2.x, capStart2.y, capEnd2.x, capEnd2.y)
  }

  renderShape() {
    const marker = this.marker
    const state = marker.state
    const shouldDraw = state.anchorPoints.length > 1 && state.controlPoints.length === state.anchorPoints.length - 1

    if (shouldDraw) {
      super.renderShape()

      if (!state.isSelected) {
        const start = state.anchorPoints[0]
        const end = state.anchorPoints[1]
        this.drawCapLines(start, end, state.capLength)
      }
    }
  }
}

export { MeasurementMarkerRenderer }
